import { addMessages } from '@hana/i18n';

// Khoá chuỗi Ezy › Dịch vụ › Biểu giá iPad (phần riêng; khoá chung ở price.i18n.ts).
addMessages('vi', {
  'pcc.detail': 'Chi tiết',
  'pcc.backList': 'Về danh sách',
  'pcc.unit': 'Đơn vị',
  'pcc.edit': 'Sửa giá',
  'pcc.propose': 'Đề xuất giá',
  'pcc.clone': 'Nhân bản dòng giá',
  'pcc.stop': 'Ngừng áp dụng',
  'pcc.viewing': 'Đang xem {v} · {st}',
  'pcc.current': 'Bản hiện hành',
  'pcc.std': 'Giá chuẩn',
  'pcc.floorV': 'Sàn {v}',
  'pcc.surPlus': '+{n} phụ thu',
  'pcc.nextShort': '{v} · từ {from}',
  'pcc.stdShort': 'Chuẩn',
  'pcc.floor40': 'Sàn 40 {v}',
});
addMessages('en', {
  'pcc.detail': 'Detail',
  'pcc.backList': 'Back to list',
  'pcc.unit': 'Unit',
  'pcc.edit': 'Edit price',
  'pcc.propose': 'Propose price',
  'pcc.clone': 'Duplicate price line',
  'pcc.stop': 'Stop applying',
  'pcc.viewing': 'Viewing {v} · {st}',
  'pcc.current': 'Current version',
  'pcc.std': 'Standard price',
  'pcc.floorV': 'Floor {v}',
  'pcc.surPlus': '+{n} surcharges',
  'pcc.nextShort': '{v} · from {from}',
  'pcc.stdShort': 'Std',
  'pcc.floor40': 'Floor 40 {v}',
});
